import { Action } from "../../../common/actions/core/action";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";
import { ActionHandler } from "../../../common/actions/core/action-handler";
import GlobalSpinnerService from "../../../common/services/spinner/global-spinner.service";
import AgreementService from "../../../common/services/agreement/agreement.service";
import MixpanelService from "../../../common/services/analytics/mixpanel.service";
import { NoAuthOpenDistantSalesAggreementAction } from "./distant-sales-dialog.action";

/* @ngInject */
export default class NoAuthDistantSalesDialogController implements ActionHandler {
    private dialogElement;
    private aggreement: string;
    private loadFailed: boolean = false;
    public saleType: string;
    public offerId?: string;
    public paymentType?: string;
    public paymentTypeMessage: string;

    protected approve: () => void;

    constructor(
        private $sce,
        private $translate,
        private $element,
        private actionDispatcher: ActionDispatcherService,
        private globalSpinner: GlobalSpinnerService,
        private agreementService: AgreementService,
        private mixpanelService: MixpanelService
    ) {
        this.actionDispatcher.register(this);
    }

    public $postLink() {
        this.dialogElement = this.$element
            .find('#distant-sales-aggreement-dialog')
            .remodal();
    }

    public $onDestroy() {
        this.actionDispatcher.unregister(this);
        this.dialogElement.destroy();
    }

    public handle(action: Action) {
        if (action instanceof NoAuthOpenDistantSalesAggreementAction) {
            this.approve = action.onApprove;
            this.saleType = action.saleType;
            this.offerId = action.offerId;
            this.paymentType = action.paymentType;
            this.openDialog();
        }
    }

    public onClick() {
        this.close();
    }

    private openDialog() {
        this.aggreement = null;
        this.loadFailed = false;
        this.agreementService
            .getDistantSalesAgreement(this.offerId)
            .then(agreement => {
                this.aggreement = this.$sce.trustAsHtml(agreement.html);
                this.dialogElement.open();
                if (agreement.versionNumber) {
                    this.mixpanelService.track('Terms Page Viewed', {
                        agreement_key: 'DISTANT_SALES',
                        terms_version: agreement.versionNumber
                    });
                }
            }).catch(() => {
                this.loadFailed = true;
                this.dialogElement.open();
            }).finally(() => this.globalSpinner.stop());
    }

    public onCancel() {
        this.close();
    }

    private close() {
        this.dialogElement.close();
    }

    private onApprove() {
        this.close();
        this.approve();
    }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/distant-sales-dialog/distant-sales-dialog.controller.ts